import { useEffect } from "react"

import { Seo } from "@trueskin-web/components"
import { useTranslation } from "@trueskin-web/translations"
import i18next from "@trueskin-web/translations"

import useCustomerMetadata from "../../hooks/use-customer-metadata"
import PageHeader from "../shared/choose-plan/page-header"
import Testimonials from "../shared/choose-plan/testimonials"
import FAQs from "../shared/faqs"

import Plans from "./components/plans"
import imageAfter from "./images/picture-after.webp"
import imageBefore from "./images/picture-before.webp"
import { faqs } from "./resources"

const ChoosePlan = () => {
  const { t } = useTranslation()
  const { userMetadata, saveAntiAgingMetadata } = useCustomerMetadata(
    "antiaging_experiment"
  )

  useEffect(() => {
    if (userMetadata && !userMetadata.antiaging_experiment) {
      const updateMetadata = async () => {
        await saveAntiAgingMetadata()
      }
      updateMetadata()
    }
  }, [userMetadata])

  return (
    <div sx={{ maxWidth: "468px", mx: "auto" }}>
      <Seo title={t("ChoosePlan.seoTitle")} />

      <PageHeader heading="Wähle ein Produkt aus:" />

      <Plans />

      <Testimonials
        imageBefore={imageBefore}
        imageAfter={imageAfter}
        title="Echte Menschen – Echte Erfolge"
        description="Nach nur 12 Wochen sehen unsere Patient:innen erste sichtbare Erfolge."
        name={
          <>
            <span sx={{ fontWeight: "bold" }}>Miriam</span>, FORMEL SKIN
          </>
        }
      />

      <FAQs items={faqs} title={i18next.t("ChoosePlan.Faqs.title")} />
    </div>
  )
}

export default ChoosePlan
